export default "__VITE_ASSET__36a03090__"